import DicksonToile from 'assets/img/dickson-toile.png';
import LatimToile from 'assets/img/latim-toile.png';
import SauledaToile from 'assets/img/sauleda-toile.png';
import formInputsTypes from '../simulatorConstant';

import StoreBanneToile from 'assets/img/store-banne-toile.png';
import StoreBrasDroits from 'assets/img/store-bras-droite.png';
import StoreDecenteVertical from 'assets/img/store-descente-verticale.png';
import StoreDoublePente from 'assets/img/store-double-pente.png';

import LamrequinDroite from 'assets/img/lambrequin-droite.png';
import LambrequinEnroulable from 'assets/img/lambrequin-enroulable.png';
import LambrequinOndulee from 'assets/img/lambrequin-ondulee.png';
import LambrequinVagues from 'assets/img/lambrequin-vagues.png';
import SansLambrequin from 'assets/img/sans-lambrequin.png';

import CoutureSimple from 'assets/img/couture-simple.png';
import Fourreau20mm from 'assets/img/fourreau-20mm.png';
import Fourreau30mm from 'assets/img/fourreau-30mm.png';
import Fourreau40mm from 'assets/img/fourreau-40mm.png';
import Fourreau50mm from 'assets/img/fourreau-50mm.png';
import Fourreau70mm from 'assets/img/fourreau-70mm.png';
import Fourreau80mm from 'assets/img/fourreau-80mm.png';
import Fourreau90mm from 'assets/img/fourreau-90mm.png';
import Jonc3mm from 'assets/img/jonc-3mm.png';
import Jonc4mm from 'assets/img/jonc-4mm.png';
import Jonc55mm from 'assets/img/jonc-5.5mm.png';
import Jonc5mm from 'assets/img/jonc-5mm.png';
import Jonc6mm from 'assets/img/jonc-6mm.png';
import Jonc7mm from 'assets/img/jonc-7mm.png';
import Jonc8mm from 'assets/img/jonc-8mm.png';

export const TOILE_STORE_BANNE = 5379;
export const FIXATION_ATTRIBUTE = 26;

const lambrequin = {
	id: 'lambrequin',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Lambrequin',
	name: 'lambrequin',
	nextStepData: false,
	nextStep: false,
	options: null,
	fetchData: (tokenUserCurent, currentFormValue, fnSuccess) => {
		let data = '';
		const generateDescription = (data) => {
			return ` ${
				currentFormValue?.StoreBanneData ? `` + currentFormValue?.StoreBanneData?.value : ''
			} ${
				currentFormValue?.manoeuvre_store
					? ` ` + currentFormValue?.manoeuvre_store?.value + ' complet'
					: ''
			} ${
				currentFormValue?.ToileStoreBanneData
					? ` \n - Toile ` + currentFormValue?.ToileStoreBanneData?.label
					: ''
			}${
				currentFormValue?.TypetoileStorebanne
					? ` \n - ` + currentFormValue?.TypetoileStorebanne?.label
					: ''
			} ${
				currentFormValue?.largeurToile
					? ` \n - Largeur de la toile ` + currentFormValue?.largeurToile + ' (mm)'
					: ''
			} ${
				currentFormValue?.projection
					? ` \n - Projection ` + currentFormValue?.projection
					: ''
			} ${
				currentFormValue?.avancee ? `\n - Avancée ` + currentFormValue?.avancee?.label : ''
			} ${
				currentFormValue?.cache
					? `\n - Couleur des caches en plastique ` + currentFormValue?.cache?.label
					: ''
			} ${
				currentFormValue?.fixation_haute
					? `\n - Fixation haute ` + currentFormValue?.fixation_haute?.label
					: ''
			} ${
				currentFormValue?.fixation_basse
					? `\n - Fixation basse ` + currentFormValue?.fixation_basse?.label
					: ''
			} ${
				currentFormValue?.type_fixation
					? `\n - Fixation ` + currentFormValue?.type_fixation?.value
					: ''
			} ${data ? `\n - ` + data : ''} ${
				currentFormValue?.capteur_vent
					? `\n - ` + currentFormValue?.capteur_vent?.value
					: ''
			} ${
				currentFormValue?.manivelle_store
					? `\n - ` + currentFormValue?.manivelle_store?.label
					: ''
			} ${
				currentFormValue?.hauteur_manivelle_store
					? `\n - Hauteur de la manivelle ` +
					  currentFormValue?.hauteur_manivelle_store?.label
					: ''
			} ${
				currentFormValue?.remplacement_telecommande?.id == 'oui_telecommande'
					? `\n - Avec télécommande `
					: ''
			} ${
				currentFormValue?.telecommande
					? `\n - ` + currentFormValue?.telecommande?.label
					: ''
			} ${
				currentFormValue?.sortie
					? `\n - Sortie électrique ` + currentFormValue?.sortie?.value
					: ''
			} 
             `;
		};
		const options = [
			{
				id: 'sans_lambrequin',
				label: 'Sans lambrequin',
				value: 'sans lambrequin',
				imageUrl: SansLambrequin,
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Sans lambrequin')),
				nextStep: false,
			},
			{
				id: 'coupe_droite',
				label: 'Coupe droite',
				value: 'coupe droite',
				imageUrl: LamrequinDroite,
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Lambrequin coupe droite')),
				nextStep: false,
			},
			{
				id: 'coupe_ondulee',
				label: 'Coupe ondulée',
				value: 'coupe ondulée',
				imageUrl: LambrequinOndulee,
				LambrequinOndulee,
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Lambrequin coupe ondulée')),
				nextStep: false,
			},
			{
				id: 'coupe_vagues',
				label: 'Coupe à vagues',
				value: 'coupe à vagues',
				imageUrl: LambrequinVagues,
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Lambrequin coupe à vagues')),
				nextStep: false,
			},
			{
				id: 'lambrequin_enroulable',
				label: 'Lambrequin enroulable 150mm',
				value: 'lambrequin enroulable 150mm',
				imageUrl: LambrequinEnroulable,
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Lambrequin enroulable 150mm')),
				nextStep: false,
			},
		];

		fnSuccess(options);
	},
};

const fixation_basse = {
	id: 'fixation_basse',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Fixation basse',
	name: 'fixation_basse',
	nextStepData: lambrequin,
	nextStep: false,
	options: null,
	fetchData: (tokenUserCurent, currentFormValue, fnSuccess) => {
		const value_ids = [
			{
				id: 202,
				name: 'Couture simple',
			},
			{
				id: 203,
				name: 'Jonc 3mm inclus',
			},
			{
				id: 204,
				name: 'Jonc 4mm inclus',
			},
			{
				id: 205,
				name: 'Jonc 5mm inclus',
			},
			{
				id: 206,
				name: 'Jonc 5.5mm inclus',
			},
			{
				id: 207,
				name: 'Jonc 6mm inclus',
			},
			{
				id: 208,
				name: 'Jonc 7mm inclus',
			},
			{
				id: 209,
				name: 'Jonc 8mm inclus',
			},
			{
				id: 210,
				name: 'Fourreau pour tube 20mm',
			},
			{
				id: 211,
				name: 'Fourreau pour tube 30mm',
			},
			{
				id: 212,
				name: 'Fourreau pour tube 40mm',
			},
			{
				id: 213,
				name: 'Fourreau pour tube 50mm',
			},
			{
				id: 214,
				name: 'Fourreau pour tube 70mm',
			},
			{
				id: 215,
				name: 'Fourreau pour tube 80mm',
			},
			{
				id: 216,
				name: 'Fourreau pour tube 90mm',
			},
		];
		const options = !!value_ids?.length
			? value_ids?.map((item) => ({
					id: item?.id,
					// label: item?.name,
					value: item?.id,
					imageUrl: (() => {
						switch (item?.id) {
							case 202:
								return CoutureSimple;
							case 203:
								return Jonc3mm;
							case 204:
								return Jonc4mm;
							case 205:
								return Jonc5mm;
							case 206:
								return Jonc55mm;
							case 207:
								return Jonc6mm;
							case 208:
								return Jonc7mm;
							case 209:
								return Jonc8mm;
							case 210:
								return Fourreau20mm;
							case 211:
								return Fourreau30mm;
							case 212:
								return Fourreau40mm;
							case 213:
								return Fourreau50mm;
							case 214:
								return Fourreau70mm;
							case 215:
								return Fourreau80mm;
							case 216:
								return Fourreau90mm;
							default:
								return null;
						}
					})(),
			  }))
			: [];
		fnSuccess(options);
	},
};

const fixation_haute = {
	id: 'fixation_haute',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Fixation haute',
	name: 'fixation_haute',
	nextStepData: fixation_basse,
	nextStep: false,
	options: null,
	fetchData: (tokenUserCurent, currentFormValue, fnSuccess) => {
		const value_ids = [
			{
				id: 202,
				name: 'Couture simple',
			},
			{
				id: 203,
				name: 'Jonc 3mm inclus',
			},
			{
				id: 204,
				name: 'Jonc 4mm inclus',
			},
			{
				id: 205,
				name: 'Jonc 5mm inclus',
			},
			{
				id: 206,
				name: 'Jonc 5.5mm inclus',
			},
			{
				id: 207,
				name: 'Jonc 6mm inclus',
			},
			{
				id: 208,
				name: 'Jonc 7mm inclus',
			},
			{
				id: 209,
				name: 'Jonc 8mm inclus',
			},
			{
				id: 210,
				name: 'Fourreau pour tube 20mm',
			},
			{
				id: 211,
				name: 'Fourreau pour tube 30mm',
			},
			{
				id: 212,
				name: 'Fourreau pour tube 40mm',
			},
			{
				id: 213,
				name: 'Fourreau pour tube 50mm',
			},
			{
				id: 214,
				name: 'Fourreau pour tube 70mm',
			},
			{
				id: 215,
				name: 'Fourreau pour tube 80mm',
			},
			{
				id: 216,
				name: 'Fourreau pour tube 90mm',
			},
		];
		const options = !!value_ids?.length
			? value_ids?.map((item) => ({
					id: item?.id,
					// label: item?.name,
					value: item?.id,
					imageUrl: (() => {
						switch (item?.id) {
							case 202:
								return CoutureSimple;
							case 203:
								return Jonc3mm;
							case 204:
								return Jonc4mm;
							case 205:
								return Jonc5mm;
							case 206:
								return Jonc55mm;
							case 207:
								return Jonc6mm;
							case 208:
								return Jonc7mm;
							case 209:
								return Jonc8mm;
							case 210:
								return Fourreau20mm;
							case 211:
								return Fourreau30mm;
							case 212:
								return Fourreau40mm;
							case 213:
								return Fourreau50mm;
							case 214:
								return Fourreau70mm;
							case 215:
								return Fourreau80mm;
							case 216:
								return Fourreau90mm;
							default:
								return null;
						}
					})(),
			  }))
			: [];
		fnSuccess(options);
	},
};

const cache = {
	id: 'cache',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Couleur des caches en plastique',
	name: 'cache',
	className: 'col-12',
	nextStep: fixation_haute,
	options: [
		{
			id: 'blanc',
			label: 'blanc',
			value: 'blanc',
			nextStep: fixation_haute,
		},
		{
			id: 'noir',
			label: 'noir',
			value: 'noir',
			nextStep: fixation_haute,
		},
	],
};

const avancee = {
	id: 'avancee',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Projection ou Avancée de toile',
	name: 'avancee',
	nextStepData: fixation_haute,
	//nextStep: fixation_haute,
	options: [
		{
			id: '150',
			label: '1500 mm',
			value: '1500 mm',
			nextStep: fixation_haute,
		},
		{
			id: '175',
			label: '1750 mm',
			value: '1750 mm',
			nextStep: fixation_haute,
		},
		{
			id: '200',
			label: '2000 mm',
			value: '2000 mm',
			nextStep: fixation_haute,
		},
		{
			id: '225',
			label: '2250 mm',
			value: '2250 mm',
			nextStep: fixation_haute,
		},
		{
			id: '250',
			label: '2500 mm',
			value: '2500 mm',
			nextStep: fixation_haute,
		},
		{
			id: '300',
			label: '3000 mm',
			value: '3000 mm',
			nextStep: fixation_haute,
		},
		{
			id: '350',
			label: '3500 mm',
			value: '3500 mm',
			nextStep: fixation_haute,
		},
	],
};

const projection = {
	id: 'L-PROJ',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'projection',
	className: 'col-6',
	label: 'Projection(mm)',
	nextStepData: avancee,
	nextStep: false,
};

const largeurToile = {
	id: 'L-TOILE',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurToile',
	className: 'col-6',
	label: 'Largeur de la toile(mm)',
	nextStepData: avancee,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

const TypetoileStorebanne = {
	id: 'T_Store',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Type de la toile',
	name: 'TypetoileStorebanne',
	nextStepData: largeurToile,
	nextStep: false,
	options: [
		{
			id: 'TSB1',
			label: 'Toile de store banne',
			value: 'Toile de store banne',
			imageUrl: StoreBanneToile,
			nextStep: false,
		},
		{
			id: 'TSBD1',
			label: 'Toile de store bras droits',
			value: 'Toile de store bras droits',
			imageUrl: StoreBrasDroits,
			nextStep: false,
		},
		{
			id: 'TSBD1',
			label: 'Toile store double pente',
			value: 'Toile store double pente',
			imageUrl: StoreDoublePente,
			nextStep: false,
		},
		{
			id: 'TSBD1',
			label: 'Toile de store à descente verticale',
			value: 'Toile de store à descente verticale',
			imageUrl: StoreDecenteVertical,
			nextStep: false,
		},
	],
};

export const ToileStoreBanneData = {
	id: 'T_Store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner une toile',
	name: 'T_Store',
	nextStepData: TypetoileStorebanne,
	nextStep: false,
	options: null,
	fetchData: (tokenUserCurent, currentFormValue, fnSuccess) => {
		const elements = [
			{
				id: 11273,
				name: 'Toile',
				display_name: 'Toile (Dickson)',
				default_code: '',
				description: '',
				list_price: 1.0,
				lst_price: 1.0,
				product_tmpl_id: 5379,
				type: 'product',
				categ_id: {
					id: 200,
					name: 'Store banne',
				},
				weight: 0.0,
				product_template_attribute_value_ids: [
					{
						id: 973,
						name: 'Dickson',
					},
				],
				brand_id: {
					id: '',
					name: '',
				},
				diametre: 0,
				active: true,
				Taille: 0,
				standard_price: 0.0,
				taxes_id: [
					{
						id: 1,
						name: '20,0%',
					},
				],
				supplier_taxes_id: [
					{
						id: 19,
						name: '20%',
					},
				],
				description_sale: '',
			},
			{
				id: 11275,
				name: 'Toile',
				display_name: 'Toile (Sauleda)',
				default_code: '',
				description: '',
				list_price: 1.0,
				lst_price: 1.0,
				product_tmpl_id: 5379,
				type: 'product',
				categ_id: {
					id: 200,
					name: 'Store banne',
				},
				weight: 0.0,
				product_template_attribute_value_ids: [
					{
						id: 975,
						name: 'Sauleda',
					},
				],
				brand_id: {
					id: '',
					name: '',
				},
				diametre: 0,
				active: true,
				Taille: 0,
				standard_price: 0.0,
				taxes_id: [
					{
						id: 1,
						name: '20,0%',
					},
				],
				supplier_taxes_id: [
					{
						id: 19,
						name: '20%',
					},
				],
				description_sale: '',
			},
			{
				id: 11278,
				name: 'Toile',
				display_name: 'Toile (Latim)',
				default_code: '',
				description: '',
				list_price: 1.0,
				lst_price: 1.0,
				product_tmpl_id: 5379,
				type: 'product',
				categ_id: {
					id: 200,
					name: 'Store banne',
				},
				weight: 0.0,
				product_template_attribute_value_ids: [
					{
						id: 978,
						name: 'Latim',
					},
				],
				brand_id: {
					id: '',
					name: '',
				},
				diametre: 0,
				active: true,
				Taille: 0,
				standard_price: 0.0,
				taxes_id: [
					{
						id: 1,
						name: '20,0%',
					},
				],
				supplier_taxes_id: [
					{
						id: 19,
						name: '20%',
					},
				],
				description_sale: '',
			},
		];

		const options = !!elements?.length
			? elements.map((item) => {
					const { product_template_attribute_value_ids } = item;
					let name = item?.display_name + ' ';
					product_template_attribute_value_ids.map((i) => (name += i.name + ' '));
					return {
						id: item?.id,
						label: name,
						value: item?.id,
						imageUrl:
							item?.id == 11273
								? DicksonToile
								: item?.id == 11275
								? SauledaToile
								: item?.id == 11278
								? LatimToile
								: null,
					};
			  })
			: [];
		fnSuccess(options);
	},
};

export default ToileStoreBanneData;
